//
import { queryList, saveObject, updateObject, getAllRoleList, getResetRoleList, getResetPwd, getDeleteUserList, getForceResetPwd, initRolePrivilegeData, initAllCounterList, unbindWx, userUpLoad, getSubclassByBusinessTypeNoList, getAllCustomerList, getAllCityList, userPointsExportData } from './../api';
import {selectRole, userType} from '../../../../api'
import { Message } from 'element-ui';
const user = {
  namespaced: true,
  state: {
    successCode: 200,
    resp: null,
    userAdd: null,
    updateData: null,
    allRoleList: null,
    resetRoleList: null,
    resetPwdList: null,
    forceResetPwdList: null,
    deleteUserList: null,
    total: null,
    userTypeObj: null,
    initRolePrivilegeDataObj: null,
    initAllCounterListObj: null,
    unbindWxResp: null,
    selectRoleInfoObj: null,
    userResp: null,
    deptObj: null,
    businesstypeSubclassList: null,
    allCustomerList: null,
    getAllCityList: null,
    userPointsExportObj: null,
  },
  mutations: {
    queryList(state, resp) {
      if (resp.code === state.successCode) {
        Message({ showClose: true, message: resp.msg, type: 'success' });
      }
      state.total = resp.total
      state.resp = (resp.obj || []).map((item, index) => {
        return {
          ...item,
          btns: [true, true, true, true, true, item.isWxBind == 'Y'],//每行数据的操作按钮权限
        }
      });
    },
    SAVE_OBJECT(state, resp) {
      state.userAdd = resp
    },
    UP_DATE_OBJECT(state, resp) {
      state.updateData = resp
    },
    GET_ALL_ROLE_LIST(state, resp) {
      state.allRoleList = resp
    },
    GET_RESET_ROLE_LIST(state, data) {
      state.resetRoleList = data
    },
    GET_RESET_PWD(state, data) {
      state.resetPwdList = data
    },
    GET_FORCE_RESET_PWD(state, data) {
      state.forceResetPwdList = data
    },
    GET_DELETE_USER(state, data) {
      state.deleteUserList = data
    },
    setData(state, data) {
      state[data.page] = data;
    },
    GET_ALL_USER_TYPE_LIST(state, data) {
      state.userTypeObj = data
    },
    INIT_ROLE_PRIVILEGE_DATA(state, data) {
      state.initRolePrivilegeDataObj = data || {};
    },
    INIT_ALL_COUNTER_LIST_DATA(state, data) {
      state.initAllCounterListObj = data.obj || [];
    },
    UN_BIND_WX_DATA(state, resp){
      state.unbindWxResp = resp || [];
    },
    SELECT_ROLEINFO_DATA(state, resp){
      state.selectRoleInfoObj = resp.obj || [];
    },
    UPLOAD_DATA(state, data) {
      state.userResp = data;
    },
    DOWN_LOAD_TEMPLATE(state, data) {
      state.templateObj = data;
    },
    GET_BUSINESSTYPE_NO_BY_SUBCLASS_NO(state, data) {
      state.businesstypeSubclassList = data.obj;
    },
    GET_ALL_CUSTOMER_LIST(state, resp) {
      state.allCustomerList = resp
      state.customerTotal = resp.total
    },
    GET_ALL_CITY_LIST(state, resp) {
      state.allCityList = resp
      state.cityTotal = resp.total
    },
    USER_POINTS_EXPORT_DATA(state, data) {
      state.userPointsExportObj = data;
    },
  },
  actions: {
    async setData({ commit }, data) {
      commit('setData', data);
    },
    async queryList({ commit }, obj) {
      let resp = await queryList(obj);
      commit('queryList', resp);
    },
    async getAddUser({ commit }, obj) {
      let resp = await saveObject(obj);
      commit('SAVE_OBJECT', resp);
    },
    async updateObject({ commit }, obj) {
      let resp = await updateObject(obj);
      commit('UP_DATE_OBJECT', resp);
    },
    async getAllRoleList({ commit }, obj) {
      let resp = await getAllRoleList(obj);
      commit('GET_ALL_ROLE_LIST', resp);
    },
    async getResetRoleList({ commit }, obj) {
      let resp = await getResetRoleList(obj);
      commit('GET_RESET_ROLE_LIST', resp);
    },
    async getResetPwd({ commit }, obj) {
      let resp = await getResetPwd(obj);
      commit('GET_RESET_PWD', resp);
    },
    async getForceResetPwd({ commit }, obj) {
      let resp = await getForceResetPwd(obj);
      commit('GET_FORCE_RESET_PWD', resp);
    },
    async getDeleteUserList({ commit }, obj) {
      let resp = await getDeleteUserList(obj);
      commit('GET_DELETE_USER', resp);
    },
    //查询carrier
    async listUserType({ commit }, obj) {
      let resp = await userType(obj);
      commit('GET_ALL_USER_TYPE_LIST', resp);
    },

    async initRolePrivilegeData({ commit }, obj) {
      let resp = await initRolePrivilegeData(obj);
      commit('INIT_ROLE_PRIVILEGE_DATA', resp);
    },
    async initAllCounterList({ commit }, obj) {
      let resp = await initAllCounterList(obj);
      commit('INIT_ALL_COUNTER_LIST_DATA', resp);
    },
    async unbindWx({ commit }, obj) {
      let resp = await unbindWx(obj);
      commit('UN_BIND_WX_DATA', resp);
    },
    //角色
    async ListRoleInfoSelect({ commit }, obj) {
      let resp = await selectRole(obj);
      commit('SELECT_ROLEINFO_DATA', resp);
    },
    //导入数据
    async userUpLoad({ commit }, obj) {
      let resp = await userUpLoad(obj);
      commit('UPLOAD_DATA', resp);
    },
    //下载模板
    async template({ commit }, obj) {
      let resp = await template(obj);
      commit('DOWN_LOAD_TEMPLATE', resp);
    },
    async getSubclassByBusinessTypeNoList({ commit }, obj) {
      let resp = await getSubclassByBusinessTypeNoList(obj);
      commit('GET_BUSINESSTYPE_NO_BY_SUBCLASS_NO', resp);
    },
    //查询客户
    async getAllCustomerList({ commit }, obj) {
      let resp = await getAllCustomerList(obj);
      commit('GET_ALL_CUSTOMER_LIST', resp);
    },
    //查询客户
    async getAllCityList({ commit }, obj) {
      let resp = await getAllCityList(obj);
      commit('GET_ALL_CITY_LIST', resp);
    },
    //用户积分导出
    async userPointsExportData({ commit }, obj) {
      let resp = await userPointsExportData(obj);
      commit('USER_POINTS_EXPORT_DATA', resp);
    },
  }
}

export default user



// WEBPACK FOOTER //
// ./src/page/auth/user/store/user.store.js